import { useEffect, useState } from 'react'
import { Visualizer } from './Visualizer'
import { Gallery } from './Gallery'
import { Privacy, Support, Terms } from './Legal'

type View = 'live' | 'gallery' | 'privacy' | 'terms' | 'support'

function viewFromHash(): View {
  const h = typeof location !== 'undefined' ? location.hash : ''
  if (h === '#gallery') return 'gallery'
  if (h === '#privacy') return 'privacy'
  if (h === '#terms') return 'terms'
  if (h === '#support') return 'support'
  return 'live'
}

/**
 * The syqel.art app. The Visualizer is the product (journey player + subscribe flow); the
 * Gallery shows the consumer catalogue (every world in dev); privacy/terms/support are
 * hash-routed static pages.
 */
export function App(): JSX.Element {
  const [view, setView] = useState<View>(viewFromHash)

  useEffect(() => {
    const onHash = (): void => setView(viewFromHash())
    window.addEventListener('hashchange', onHash)
    return () => window.removeEventListener('hashchange', onHash)
  }, [])

  if (view === 'privacy') return <Privacy />
  if (view === 'terms') return <Terms />
  if (view === 'support') return <Support />
  // navigation lives in the views themselves (panel ⊞ → gallery; gallery logo → player) —
  // no floating toggle: switching views tears down audio, so it must be a deliberate act
  return view === 'gallery' ? <Gallery /> : <Visualizer />
}
